export default __webpack_public_path__ + "static/media/resource-desk-featured-image-placeholder.fbe2511b.svg";